import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { DadosLogin } from '../auth/interfaces/dados-login.interface';
import { SideMenu } from '../models';

export interface Portal {
    grupo_usuario: string;
    link: string;
}

@Injectable({
    providedIn: 'root',
})
export class PortalService {
    private _portais = new BehaviorSubject<Array<Portal>>([]);
    get portais() {
        return this._portais.asObservable();
    }

    private _portalTitle = new BehaviorSubject<string>('');
    get portalTitle() {
        return this._portalTitle.asObservable();
    }

    private _links = new BehaviorSubject<Array<SideMenu>>([]);
    get links() {
        return this._links.asObservable();
    }

    setPortais(grupos: DadosLogin['grupos']) {
        return this._portais.next(this.parsePermissions(grupos));
    }

    setPortalTitle(portalTitle: string) {
        return this._portalTitle.next(portalTitle);
    }

    setLinks(links: Array<SideMenu>) {
        return this._links.next(links);
    }

    getLinks() {
        return this._links.value;
    }

    private parsePermissions(res: DadosLogin['grupos']) {
        return (
            res
                // .filter(el => el.id_grupo_usuario.grupo_usuario !== 'Coordenador')
                .reduce((acc, red) => {
                    acc.push({ ...red.id_grupo_usuario });
                    return acc;
                }, [])
        );
    }
}
